export default "__VITE_ASSET__2480a8f1__"